require.register("description/util/processor", function(exports, require, module){
  $0
  
});

